import {
  SignInType,
  type GetSignInUrlArgs,
  type SessionMetadata,
  type SignInArgs,
} from '@bbkAdminRedux/rtkq/auth-types';
import { type BbkClientConfig } from '@bbkAdminRedux/rtkq/preauth-company.slice';
import { AuthChargebee } from '@bbkAdminUtils/auth-chargebee';
import { AuthDev } from '@bbkAdminUtils/auth-dev';

/**
 * Orchestrates the interactive sign-in entry points. Session lifecycle after
 * sign-in (refresh, logout, upgrade) is backend-owned and handled by the
 * cookie-only `/api/v1/auth/session/*` endpoints in {@code brightbackAuthSlice},
 * so this class only covers the initial credential exchange and the redirect to
 * the Chargebee IDP login page.
 */
export class BrightbackAuth {
  private devAuth: AuthDev;

  private chargebeeAuth: AuthChargebee;

  constructor(config: BbkClientConfig) {
    this.devAuth = new AuthDev();
    this.chargebeeAuth = new AuthChargebee(config);
  }

  public signIn(opts: SignInArgs): Promise<SessionMetadata> {
    switch (opts.type) {
      case SignInType.DEV:
        return this.devAuth.signIn(opts);
      case SignInType.CHARGEBEE:
        return this.chargebeeAuth.signIn(opts);
      default:
        throw new Error('Invalid sign-in type');
    }
  }

  public getSignInUrl(opts: GetSignInUrlArgs): Promise<string> {
    switch (opts.type) {
      case SignInType.CHARGEBEE: {
        return Promise.resolve(this.chargebeeAuth.getSignInUrl(opts));
      }
      default: {
        throw new Error('Invalid sign-in type');
      }
    }
  }
}
